

































import { Component, Prop, Vue } from "vue-property-decorator"
import AuthSecurityCode from "@/components/Auth/AuthSecurityCode.vue"
import AuthErrorAlert from "@/components/Auth/AuthErrorAlert.vue"
import AuthResendBtn from "@/components/Auth/AuthResendBtn.vue"
import { ValidationObserver } from "vee-validate"
import { mapState } from "vuex"

@Component({
  components: {
    AuthSecurityCode,
    AuthErrorAlert,
    AuthResendBtn,
    ValidationObserver,
  },
  computed: {
    ...mapState("Auth", {
      loginDetails: "loginDetails",
      activeRoleKey: "activeRoleKey",
    }),
  },
})
export default class LoginSecurityCode extends Vue {
  @Prop() readonly roleKey!: any

  loginDetails!: {
    email: string;
    totp: string;
  }

  activeRoleKey!: string

  errors = {}

  isLoading = false

  time = 29

  handleLogin() {
    if (this.loginDetails.totp.length != 4) {
      this.errors = [{ security_code: "Invalid Code" }]
      return
    }
    this.isLoading = true
    this.$store
      .dispatch(`Auth/${this.roleKey}AttemptLogin`)
      .then((response) => {
        if (response.status) {
          this.$router.push({ name: this.roleKey + "-dashboard" })
        } else {
          this.isLoading = false
          this.errors = response.message
        }
      })
  }

  handleResendEmail() {
    this.loginDetails.totp = ""
    return this.$store.dispatch(`Auth/${this.roleKey}AttemptLogin`)
  }
}
